import React from 'react';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import LogLineTooltip from '../../../components/LogLine/LogLineTooltip';
import phraseTypes from '../../../../const/phraseTypes';
import { List, AutoSizer } from 'react-virtualized/dist/commonjs';
import projectLogsKeeper from '../../../../services/dataKeepers/ProjectLogsKeeper';
import AnalyticIntentsVariableFilters from './AnalyticIntentsVariableFilters';
import noLogsImg from '../../../../assets/images/logs/no-logs-01-pic@2x.png';
import {
    OUTPUT_PHRASES,
    INPUT_PHRASES,
    UNRECOGNIZED_PHRASES,
} from '../../../../const/logFilters';
import LogLineWrapper from '../../../components/LogLine/LogLineWrapper';
import { AnalyticsSimpleTile } from '../AnalyticsSimpleTile/AnalyticsSimpleTile';
import { AnalyticsPopupTile } from '../AnalyticsPopupTile/AnalyticsPopupTile';
import { AnalyticsSimpleTileCollapser } from '../AnalyticsSimpleTile/AnalyticsSimpleTileCollapser';
import AnalyticIntentsConstantFilters from './AnalyticIntentsConstantFilters';
class AnalyticIntentsTile extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            logsScrollTs: 0,
            //react-virtualized stuff
            listRowHeight: 24, // log line height (defined in css)
            overscanRowCount: 2,
            scrollToIndex: undefined,
            showLogTooltip: false,
            listScrolledAfterFirstRender: false
        };

        this.debouncedScroll = _.debounce(this.scrollCb, 300);
    }

    componentDidMount() {
        window.addEventListener('mousedown', this.handleClickOutsideCb, false);
        this._isMounted = true;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.report?.data?.intentsDataUpdateTs !== nextProps.report?.data?.intentsDataUpdateTs) {
            return true;
        }

        if (JSON.stringify(this.props.filters) !== JSON.stringify(nextProps.filters)) {
            return true;
        }
        if (this.props.selectedDialogId !== nextProps.selectedDialogId) {
            return true;
        }
        if (this.props.selectedPatternId !== nextProps.selectedPatternId) {
            return true;
        }
        if (this.props.hasFilterByPhrases !== nextProps.hasFilterByPhrases) {
            return true;
        }
        if (this.state.showLogTooltip !== nextState.showLogTooltip) {
            return true;
        }
        if (JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)) {
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.handleClickOutsideCb, false);
    }

    componentDidUpdate(prevProps) {
        const intentsUpdateTs = this.props.report?.data?.intentsUpdateTs;
        const prevIntentsUpdateTs = prevProps.report?.data?.intentsUpdateTs;

        if (intentsUpdateTs !== prevIntentsUpdateTs) {
            setTimeout(() => {
                if (this.list) {
                    this.list.forceUpdateGrid();
                }
            }, 0);
        }
    }

    setFilter = (filterName, filterValue, e) => {
        this.setState({ listScrolledAfterFirstRender: false }, () => {
            this.props.setFilterCb(filterName, filterValue, e);
        });
    }

    setUnrecognizedPhrasesFilter = (e) => {
        this.setFilter(UNRECOGNIZED_PHRASES, null, e);
    }

    setInputPhrasesFilter = (e) => {
        this.setFilter(INPUT_PHRASES, null, e);
    }

    setOutputPhrasesFilter = (e) => {
        this.setFilter(OUTPUT_PHRASES, null, e);
    }

    setFilterByPhrase = (filterName, filterValue, e) => {
        this.setFilter(filterName, filterValue, e);
    }

    goToErrorToLine = (errInfo) => {
        this.goToError({ ...errInfo, ...{ character: 0 } });
    }

    goToError = (errInfo) => {
        const { project } = this.props;
        if (this.props.setStageMode) {
            this.props.setStageMode(true);
        }
        this.props.highlightLine({
            project: project,
            scriptName: errInfo.file,
            lineNumber: errInfo.line,
            character: errInfo.character,
            lineType: 'error',
            scriptsHash: errInfo.scriptsHash
        });
    }

    getIntents = (props) => {
        return props.report?.data?.intents;
    }

    getDisplayedLogs = () => {
        let { filters } = this.props;
        let intents = this.getIntents(this.props);

        if (!filters[INPUT_PHRASES]) {
            intents = _.filter(intents, function (el) {
                let phraseType;
                if (el.type) {
                    phraseType = phraseTypes[el.type.toLowerCase()];
                    if (phraseType === phraseTypes.input && el.notFound === false) {
                        return false;
                    }
                    return true;
                }

                return true;
            });
        }

        if (!filters[OUTPUT_PHRASES]) {
            intents = _.filter(intents, function (el) {
                let phraseType;
                if (el.type) {
                    phraseType = phraseTypes[el.type.toLowerCase()];
                    if (phraseType !== phraseTypes.output) {
                        return true;
                    }
                    return false;
                }

                return true;
            });
        }

        if (!filters[UNRECOGNIZED_PHRASES]) {
            intents = _.filter(intents, function (el) {
                let phraseType;
                if (el.type) {
                    phraseType = phraseTypes[el.type.toLowerCase()];
                    if (phraseType === phraseTypes.input || phraseType === phraseTypes.output) {
                        return el.notFound === false;
                    }
                }

                return true;
            });
        }


        return intents || [];
    }

    setListInView = (ref) => {
        this.list = ref;
    }
    handleScroll = ({ clientHeight, scrollHeight, scrollTop }) => {
        this.debouncedScroll({ clientHeight, scrollHeight, scrollTop });
    }

    getTooltipContent = () => {
        const {
            getLogImage,
            projectId,
            environment,
            filters,
            filterUpdateTs
        } = this.props;

        const log = projectLogsKeeper.logInTooltip;

        return <LogLineTooltip
            filterUpdateTs={filterUpdateTs}
            log={log}
            projectId={projectId}
            goToCb={this.goToErrorToLine}
            closeLogTooltip={this.closeLogTooltip}
            getLogImage={getLogImage}
            environment={environment}
            filters={filters}
            setFilterByPhrase={this.setFilterByPhrase} />;
    }

    openLogTooltip = () => {
        this.setState({ showLogTooltip: true });
    }

    closeLogTooltip = () => {
        projectLogsKeeper.logInTooltip = {};
        this.setState({ showLogTooltip: false });
    }

    handleClickOutsideCb = (e) => {
        const log = projectLogsKeeper.logInTooltip;
        const el = e.target;

        if (_.isEmpty(log)) {
            return;
        }

        if (el.className.indexOf('log-tooltip-overlay') > -1) {
            this.closeLogTooltip();
        }
    }

    rowRenderer = (option) => {
        const { filterUpdateTs, filters } = this.props;
        return <LogLineWrapper
            key={`${option.key}`}
            logs={this.getDisplayedLogs()}
            {...option}
            goToCb={this.goToErrorToLine}
            closeLogTooltipCb={this.closeLogTooltip}
            openLogTooltipCb={this.openLogTooltip}
            setFilterByPhraseCb={this.setFilterByPhrase}
            filterUpdateTs={filterUpdateTs}
            filters={filters}
            intentLinkMode="icon"
        />;
    }

    scrollCb = ({ clientHeight, scrollHeight, scrollTop }) => {
        if (!this._isMounted) return;
        if (clientHeight !== 0) {
            if (clientHeight < scrollHeight && scrollHeight - scrollTop !== clientHeight) {
                this.autoscroll = false;
            } else {
                this.setState({ logsScrollTs: Date.now() });
                this.autoscroll = true;
            }
        } else {
            this.setState({ logsScrollTs: Date.now() });
            this.autoscroll = true;
        }
    }

    onRowsRendered = () => {
        const { listScrolledAfterFirstRender } = this.state;
        if (this.list && !listScrolledAfterFirstRender) {
            this.list.scrollToRow(this.getDisplayedLogs().length);
            this.setState({ listScrolledAfterFirstRender: true });
        }
    }

    renderList = ({ height, width }) => {
        const { logsUpdatedTs } = this.props;
        const { overscanRowCount, listRowHeight } = this.state;

        let displayedLogs = this.getDisplayedLogs();
        let scrollToIndex;

        if (this.autoscroll) {
            scrollToIndex = displayedLogs.length;
        }

        return <List
            ref={this.setListInView}
            height={height}
            overscanRowCount={overscanRowCount}
            rowCount={displayedLogs.length}
            onScroll={this.handleScroll}
            logsUpdatedTs={logsUpdatedTs}
            rowHeight={listRowHeight}
            scrollToIndex={scrollToIndex}
            scrollToAlignment="start"
            rowRenderer={this.rowRenderer}
            onRowsRendered={this.onRowsRendered}
            width={width}
        />;
    }

    render() {
        const {
            environment,
            filters,
            hasFilterByPhrases,
            resetAllPhrasesFilters,
            resetPatternFilter,
            resetPhraseTextFilter,
            resetEntityFilter,
            resetDialogFilter,
            selectedDialogId,
            selectedPatternId,
        } = this.props;

        let intents = this.getIntents(this.props);

        const { showLogTooltip } = this.state;

        const displayedIntents = this.getDisplayedLogs();

        return (
            <AnalyticsSimpleTile {...this.props}>
                <div
                    className={`analytic-intents-tile ${environment} ${(selectedDialogId || selectedPatternId) && 'filtered-analytics-tile'}`}>
                    <div className="analytic-intents-tile_header-wrapper">
                        <AnalyticsSimpleTileCollapser {...this.props}>
                            <div className="analytic-tile_header">
                                Interactions
                            </div>
                        </AnalyticsSimpleTileCollapser>
                        <AnalyticIntentsConstantFilters
                            filters={filters}
                            intents={intents}
                            hasFilterByPhrases={hasFilterByPhrases}
                            setFilter={this.setFilter}
                            resetAllPhrasesFilters={resetAllPhrasesFilters}
                            resetPatternFilter={resetPatternFilter}
                            resetPhraseTextFilter={resetPhraseTextFilter}
                            resetEntityFilter={resetEntityFilter}
                            resetDialogFilter={resetDialogFilter} />
                    </div>
                    <AnalyticIntentsVariableFilters
                        filters={filters}
                        hasFilterByPhrases={hasFilterByPhrases}
                        setFilter={this.setFilter}
                        resetAllPhrasesFilters={resetAllPhrasesFilters}
                        resetPatternFilter={resetPatternFilter}
                        resetPhraseTextFilter={resetPhraseTextFilter}
                        resetEntityFilter={resetEntityFilter}
                        resetDialogFilter={resetDialogFilter}
                    />
                    <div className="analytic-intents-tile_body">
                        {displayedIntents.length > 0 ?
                            <AutoSizer
                                rowCount={displayedIntents.length}>
                                {this.renderList}
                            </AutoSizer>
                            : <div className="analytic-intents-tile_no-data">
                                <div>
                                    <img src={noLogsImg} />
                                    <div>No interactions</div>
                                </div>
                            </div>
                        }
                        {showLogTooltip && this.getTooltipContent()}
                    </div>
                </div>
            </AnalyticsSimpleTile>
        );
    }
}


export default AnalyticsPopupTile(AnalyticIntentsTile);
